// see documentation at https://developer.apple.com/library/content/featuredarticles/iPhoneURLScheme_Reference/MapLinks/MapLinks.html#//apple_ref/doc/uid/TP40007899-CH5-SW1
export const computeDirectionsUrl = (
    addressLine1: string,
    addressLine2: string,
): string => {
    const destination = addressLine2 ? `${addressLine1} ${addressLine2}` : addressLine1;
    return `http://maps.apple.com/?daddr=${encodeURIComponent(destination)}`;
};
